import {
  JsonSchemaProperty,
  RowDataReducerState,
  RowDataReducerAction,
} from "../../types";
import { addObjectAction, deleteObjectAction } from "./actionHandlers/addDeleteObjectsActions";
import { addMultiValuedFieldAction } from "./actionHandlers/addMultiValuedFieldAction";
import {
  addObjectRowAction,
} from "./actionHandlers/addObjectRowAction";
import { addSchemaPropertyAction } from "./actionHandlers/addSchemaPropertyAction";
import { deleteObjectRowAction } from "./actionHandlers/deleteObjectRowAction";
import { emptyCoRelationArrayAction } from "./actionHandlers/emptyCoRelationArrayAction";
import { removeMultiValuedFieldAction } from "./actionHandlers/removeMultiValuedFieldAction";
import { setDeletedObjectsAction } from "./actionHandlers/setDeletedObjectsAction";
import { updateFieldAction } from "./actionHandlers/updateFieldAction";
import { updateFieldValidationAction } from "./actionHandlers/updateFieldValidationAction";
import { updateObjectRowAction } from "./actionHandlers/updateObjectRowAction";
import { updateResetFieldAction } from "./actionHandlers/updateResetFieldAction";
import { updateRowDataReducerState } from "./actionHandlers/updateRowDataReducerState";
import { updateSchemaPropertyField } from "./actionHandlers/updateSchemaPropertyField";

export default function rowDataReducer(
  state: RowDataReducerState,
  action: RowDataReducerAction,
): RowDataReducerState {
  const { payload } = action;
  if (!payload) return state;

  const { propertyKey } = payload;
  const { schema } = state;
  const property = schema.properties[propertyKey as keyof JsonSchemaProperty];

  switch (action.type) {
    case "UPDATE_FIELD":
      return updateFieldAction(payload, state, property);

    case "UPDATE_RESET_FIELD":
      return updateResetFieldAction(payload, state);

    case "UPDATE_FIELD_VALIDATION":
      return updateFieldValidationAction(payload, state);

    case "ADD_MULTI_VALUED_FIELD":
      return addMultiValuedFieldAction(payload, state, property);

    case "REMOVE_MULTI_VALUED_FIELD":
      return removeMultiValuedFieldAction(payload, state, property);

    case "ADD_OBJECT_ROW":
      return addObjectRowAction(payload, state, property);

    case "DELETE_OBJECT_ROW":
      return deleteObjectRowAction(payload, state);

    case "UPDATE_OBJECT_ROW":
      return updateObjectRowAction(payload, state);

    case "SET_DELETED_OBJECTS":
      return setDeletedObjectsAction(payload, state);

    case "UPDATE_SCHEMA_PROPERTY_FIELD":
      return updateSchemaPropertyField(payload, state);

    case "ADD_SCHEMA_PROPERTY":
      return addSchemaPropertyAction(payload, state);

    case "UPDATE_ROW_DATA_REDUCER_STATE":
      return updateRowDataReducerState(payload, state);

    case "ADD_SINGLE_OBJECT":
      return addObjectAction(payload, state, property);

    case "DELETE_SINGLE_OBJECT":
      return deleteObjectAction(payload, state);

    case "EMPTY_CORELATION_ARRAY":
      return emptyCoRelationArrayAction(payload, state);

    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}
